import React from "react";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import regame1 from "../../assets/regame/Regame0.1.png";

const ReGame = () => {
    const images = [
        { image: "https://i.ibb.co/cXFmBNZ/Regame1.png" },
        { image: "https://i.ibb.co/2k7gPrx/Regame2.png" },
        { image: "https://i.ibb.co/cg9WwSr/Regame3.png" },
        {
            image: "https://i.ibb.co/8jzvLXY/Regame4.png",
        },
        {
            image: "https://i.ibb.co/drQYJ0C/Regame5.png",
        },
        {
            image: "https://i.ibb.co/TgHFwHd/Regame6.png",
        },
        {
            image: "https://i.ibb.co/ZH3VGBC/Regame7.png",
        },
        {
            image: "https://i.ibb.co/9TJjhvs/Regame8.png",
        },
        {
            image: "https://i.ibb.co/hfPQFpz/Regame9.png",
        },
        {
            image: "https://i.ibb.co/Q616kSb/Regame10.png",
        },
        {
            image: "https://i.ibb.co/XXzjkwQ/Regame11.png",
        },
        {
            image: "https://i.ibb.co/k6KRRr8/Regame12.png",
        },
    ];
    return (
        <div>
            <img src={regame1} className="w-full" alt="website" />
            <div className="w-full px-4 md:px-10 lg:p-0 lg:w-4/5 mx-auto flex justify-center items-center lg:items-start flex-col lg:flex-row mt-8 text-justify dark:text-[#E9F8F9]">
                <div className="w-full lg:w-[80%] lg:pr-8 ">
                    <h3 className="font-bold text-xl">Description</h3>
                    <div className="mt-5">
                        <h4>
                            ReGame is a full stack resale market website where
                            you can buy, sell games.
                        </h4>
                        <ul className="list-disc ml-5 mt-3">
                            <li className="mb-2">
                                Users can create their account with an email password login. It is produced by Firebase authentication.
                            </li>
                            <li className="mb-2">
                                Users cannot buy or book products if they do not log in.
                            </li>
                            <li className="mb-2">
                            This site has a dashboard system.
                            </li>
                            <li className="mb-2">
                                Users/Buyer will see their specific options, Buyers will see My Orders, and Sellers will see Add A Product and My Products.
                            </li>
                            <li className="mb-2">
                                The Seller can advertise a product, and the Buyer can report a product.
                            </li>
                            <li className="mb-2">
                                JWT protects all dashboard routes.
                            </li>
                            <li>
                                Admin can delete or make admin a user.
                            </li>
                            <li>
                                There is a payment system. Stripe integrates the payment system.
                            </li>
                        </ul>
                    </div>
                    {/* <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
                        <img src={regameDetails1} alt="" />
                        <img src={regameDetails2} alt="" />
                        <img src={regameDetails3} alt="" />
                        <img src={regameDetails4} alt="" />
                    </div> */}
                    <Swiper
                        className="mt-8 w-96 md:w-10/12 cursor-grab "
                        modules={[Pagination]}
                        spaceBetween={40}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                    >
                        {images.map((photo, id) => (
                            <SwiperSlide className="rounded-lg" key={id}>
                                <img
                                    className="rounded-lg pb-10"
                                    src={photo.image}
                                    alt=""
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <h3 className="font-bold text-xl">Technologies Used</h3>
                    <div className="mt-5">
                        <ul className="list-disc ml-5 mt-3">
                            <li className="mb-2">React.js</li>
                            <li className="mb-2">Tailwind CSS</li>
                            <li className="mb-2">DaisyUi</li>
                            <li className="mb-2">Firebase</li>
                            <li className="mb-2">Node.js</li>
                            <li className="mb-2">JWT</li>
                            <li className="mb-2">MondoDb</li>
                            <li className="mb-2">Express.js</li>
                            <li className="mb-2">React Router Dom</li>
                            <li className="mb-2">React Hot Toast</li>
                        </ul>
                    </div>
                </div>

                <div className="w-full my-8 lg:mt-0 lg:w-1/4 lg:pr-5">
                    <h3 className="font-bold text-xl">Details</h3>

                    <div>
                        <h4 className="font-semibold mt-3">Live Site</h4>
                        <a
                            href="https://regames-12bd9.web.app/"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ReGame
                        </a>
                    </div>

                    <div>
                        <h4 className="font-semibold mt-3">Client Side Code</h4>
                        <a
                            href="https://github.com/nabilAhmedN/reGame"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ./<spna className="underline">nabilAhmedN</spna>/
                            <span className="underline">reGame</span>
                        </a>
                    </div>

                    <div>
                        <h4 className="font-semibold mt-3">Server Side Code</h4>
                        <a
                            href="https://github.com/nabilAhmedN/reGame-server"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ./<spna className="underline">nabilAhmedN</spna>/
                            <span className="underline">reGame-server</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReGame;
